// extracted by mini-css-extract-plugin
export var readonly = "_i9-1";
export var star = "_i9-0";